import React from 'react'
import './skeleton-seats-calcutated-selection.css'

import { SkeletonPartialSeatsCalcutatedSelection } from '../skeleton-partial-calculated-values'

export const SkeletonSeatsCalculatedSelection = () => {
	return (
		<div className="skeleton-container">
			<span>..........................</span>
			<div>
				<div>
					<div>
						<span>......................</span>
						<span>..................</span>
					</div>
				</div>
				<hr />
				<SkeletonPartialSeatsCalcutatedSelection />
			</div>
		</div>
	)
}
